import { Component, Input, OnInit } from '@angular/core';
import { TranslateService }         from '@ngx-translate/core';

import { ApiService }      from '../api/api.service';
import { CustomerModel }   from './models/customer';
import { Table }           from '../table/types/table';
import { TableQueryModel } from '../../app-customer/table/models/table-query';

@Component({
  selector   : 'wor-customer-activity-logs',
  template: require('./customer.activity-logs.component.html')
})
export class CustomerActivityLogsComponent implements OnInit {
  @Input() customer : CustomerModel;

  logs : Array<any>;

  tableSettings : Table = {
    columns: [
      {
        field : 'created_by',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.SOURCE')
        }
      },
      {
        classes: 'all-caps',
        field  : 'activity_type',
        header : {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.TYPE')
        }
      },
      {
        field : 'date',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.DATE')
        },
        pipe: 'dateTime'
      },
      {
        field : 'activity',
        header: {
          text: this.translateService.instant('INVOICE_SPACE.ACTIVITY')
        }
      },
      {
        field : 'user',
        header: {
          text: this.translateService.instant('COMPANY_SPACE.USERS.USER')
        }
      }
    ],
    empty: {
      text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_ACTIVITY_LOGS'),
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => this.apiService.get('/customer_activity_log_count', this.customer.id)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  constructor (
    private apiService      : ApiService,
    private translateService: TranslateService
  ) {}

  ngOnInit () : void {
    this.getLogs({
      pageSize: this.tableSettings.pagination.pageSize,
      offset  : 0
    } as TableQueryModel);
  }

  getLogs ( params : TableQueryModel ) : ng.IPromise<Array<any>> {
    return this.apiService.get('/customer_activity_logs', [
        this.customer.id,
        params.pageSize,
        params.offset
      ])
      .then((logs : Array<any>) => {
        this.logs = logs;

        return logs;
      });
  }
}
